import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { shallow } from 'zustand/shallow';

import { LoadingSpinner } from '../../components/Molecules';
import { WebStoreRoleDetailTemplate } from '../../components/Templates';
import {
  DEFAULT_DISTRIBUTORID,
  DEFAULT_PARTNERID,
} from '../../constants/appInfo';
import useRedirectEntry from '../../hooks/useRedirectEntry';
import useRedirectHome from '../../hooks/useRedirectHome';
import { ReferralSystem } from '../../models/RewardStore';
import { useRewardStore } from '../../stores/RewardStore';
import { useSessionStore } from '../../stores/SessionStore';
import { useUserStore } from '../../stores/UserStore';
import { capitalizeFirst } from '../../utils/string';

type State = {
  loadingTotal: number;
  finishRewardReferral: boolean;
  userRewardReferralCode: string | undefined;
};

const { fetchRewardReferral } = useRewardStore.getState();

const WebStoreRoleDetailScreen = () => {
  const navigate = useNavigate();

  const userId = useSessionStore((store) => store.activeUserId);

  const userProfile = useUserStore((store) => store.getProfile(userId ?? ''));

  const [state, setState] = useState<State>({
    loadingTotal: 0,
    finishRewardReferral: false,
    userRewardReferralCode: undefined,
  });

  useRedirectEntry();

  const getReferralCode = useCallback(async () => {
    setState((s) => ({ ...s, loadingTotal: s.loadingTotal + 1 }));
    const referralCodeData = await useRewardStore
      .getState()
      .getRewardReferralCode(ReferralSystem.Joyajoy);
    setState((s) => ({ ...s, loadingTotal: s.loadingTotal - 1 }));
    if (referralCodeData) {
      setState((s) => ({
        ...s,
        userRewardReferralCode: referralCodeData.referralCode,
      }));
    }
  }, []);

  useEffect(() => {
    if (userId) {
      getReferralCode().catch(console.error);
    }
  }, [getReferralCode, userId]);

  useEffect(() => {
    if (userId) {
      setState((s) => ({ ...s, loadingTotal: s.loadingTotal + 1 }));
      fetchRewardReferral({ referralSystem: ReferralSystem.Joyajoy })
        .catch(console.error)
        .finally(() => {
          setState((s) => ({
            ...s,
            loadingTotal: s.loadingTotal - 1,
            finishRewardReferral: true,
          }));
        });
    }
  }, [userId]);

  const rewardReferral = useRewardStore(
    (store) => store.getRewardReferral(`${ReferralSystem.Joyajoy}_${userId}`),
    shallow,
  );

  useRedirectHome(
    state.finishRewardReferral && !rewardReferral?.isPartnerOrDistributorRole,
  );

  const onClickRenew = useCallback(() => {
    console.log('clickedrenew'); // TODO: implement renew
  }, []);

  const onClickReferRole = useCallback(() => {
    navigate(`/store/${DEFAULT_DISTRIBUTORID}`);
  }, [navigate]);

  const onClickReferPartner = useCallback(() => {
    navigate(`/store/${DEFAULT_PARTNERID}`);
  }, [navigate]);

  return (
    <>
      {state.loadingTotal ? (
        <LoadingSpinner loading={!!state.loadingTotal} />
      ) : null}
      <WebStoreRoleDetailTemplate
        roleName={capitalizeFirst(rewardReferral?.role ?? '')}
        profile={userProfile}
        expiredAt={rewardReferral?.expiredAt}
        userRewardReferralCode={state.userRewardReferralCode}
        onClickRenew={onClickRenew}
        onClickReferRole={onClickReferRole}
        onClickReferPartner={onClickReferPartner}
      />
    </>
  );
};

export default WebStoreRoleDetailScreen;
